import type { AchievementBackgroundProps } from '../Achievement';

export const BronzePlaceholder = ({ size }: AchievementBackgroundProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.5371 6.47461C33.6119 3.60088 38.3881 3.60088 41.4629 6.47461L47.291 11.9219C48.4064 12.9643 49.7465 13.7379 51.207 14.1826L58.8389 16.5068C62.8649 17.7328 65.253 21.8682 64.3018 25.9678L62.498 33.7393C62.1529 35.2265 62.1529 36.7735 62.498 38.2607L64.3018 46.0322C65.253 50.1319 62.8649 54.2672 58.8389 55.4932L51.207 57.8174C49.7465 58.2621 48.4064 59.0357 47.291 60.0781L41.4629 65.5254C38.3881 68.3991 33.6119 68.3991 30.5371 65.5254L24.709 60.0781C23.5936 59.0357 22.2535 58.2621 20.793 57.8174L13.1611 55.4932C9.13513 54.2672 6.74697 50.1318 7.69824 46.0322L9.50195 38.2607C9.84706 36.7735 9.84706 35.2265 9.50195 33.7393L7.69824 25.9678C6.74697 21.8682 9.13513 17.7328 13.1611 16.5068L20.793 14.1826C22.2535 13.7379 23.5936 12.9643 24.709 11.9219L30.5371 6.47461Z"
      fill="#EAEAEC"
      stroke="#9FA3A7"
      strokeWidth="2"
    />
  </svg>
);
